import * as React from 'react';
import { SVGProps } from 'react';

const SvgHilbiSymbol = (props: SVGProps<SVGSVGElement>) => (
  <svg width={41} height={40} viewBox="0 0 41 40" fill="none" role="img" {...props}>
    <circle cx={20.5} cy={20} r={20} fill="#fff" />
    <path
      d="M36.5 20c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.177 11.519a1.773 1.773 0 0 0 0 2.507l7.192 7.192a1.773 1.773 0 0 0 2.506-2.506l-7.192-7.193a1.768 1.768 0 0 0-1.253-.52c-.454 0-.907.174-1.253.52Zm-7.158 7.158a1.771 1.771 0 0 0 0 2.506l7.192 7.192a1.772 1.772 0 1 0 2.507-2.507l-7.192-7.191a1.768 1.768 0 0 0-2.507 0Zm7.163 2.536a1.79 1.79 0 1 1 2.53-2.531 1.79 1.79 0 0 1-2.53 2.53Z"
      fill="#fff"
    />
  </svg>
);

export default SvgHilbiSymbol;
